import React from "react";
import { GroupMarketPageView } from "./view";
import { GroupMarketPageController } from "./controller";
import { styles } from "./styles";

export class GroupMarketPage extends React.Component {
  controller = new GroupMarketPageController(this.props);

  render() {
    return (
      <GroupMarketPageView
        {...this.props}
        controller={this.controller}
        styles={styles}
      />
    );
  }
}
